export default __webpack_public_path__ + "static/media/logoGo.0480562d.png";